import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App';
import './index.css';
import AboutPage from "./AboutPage";
import FeatureSectionPage from './FeaturePage';
import OrganizerTeamPagePage from './OrganizerTeamPage';
import FaqPage from './FaqPage';
import BookingPage from './BookingPage';
import BookingConfirmation from './BookingConfirmation';
import UpiPayment from './UpiPayment';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={
          <div className="animate-fade-in-scale">
            <App />
          </div>
        } />
               <Route path="/about-leaguesphere" element={<AboutPage />} />
               <Route path="/feature" element={<FeatureSectionPage />} />
               <Route path="/organizer-team" element={<OrganizerTeamPagePage />} />
               <Route path="/faq" element={<FaqPage />} />
               <Route path="/booking" element={<BookingPage />} />
               <Route path="/booking-confirmation" element={<BookingConfirmation />} />
               <Route path="/upi-payment-link" element={<UpiPayment />} />
      </Routes>
    </Router>
  </React.StrictMode>
);
